module.exports = __webpack_public_path__ + "media/clap-loud.c2030d5b.mp3";